import React from "react";
import { Link, useLocation } from "react-router-dom";

const UserSidebarContainer = () => {
  const location = useLocation();
  const sidebarColor = "#1e2e38";
  const activeColor = "#2f4f5f"; // Highlight color

  const getNavStyle = (path) => ({
    backgroundColor: location.pathname === path ? activeColor : sidebarColor,
    borderLeft:
      location.pathname === path ? "4px solid #00c0ef" : "4px solid transparent",
    transition: "all 0.3s ease",
  });

  return (
    <>
      <div className="sidebar-container">
        <div className="sidemenu-container navbar-collapse collapse fixed-menu">
          <div
            id="remove-scroll"
            className="left-sidemenu"
            style={{ backgroundColor: sidebarColor }}
          >
            <ul
              className="sidemenu page-header-fixed slimscroll-style"
              data-keep-expanded="false"
              data-auto-scroll="true"
              data-slide-speed="200"
            >
              <li className="sidebar-toggler-wrapper hide">
                <div className="sidebar-toggler">
                  <span></span>
                </div>
              </li>

              <li className="nav-item start">
                <Link
                  to="/index"
                  className="nav-link nav-toggle"
                  style={getNavStyle("/index")}
                >
                  <i data-feather="home" style={{ color: "#FFF" }}></i>
                  <span className="title" style={{ color: "#FFF" }}>
                    Dashboard
                  </span>
                </Link>
              </li>

              <li className="nav-item start">
                <Link
                  to="/UserMyCases"
                  className="nav-link nav-toggle"
                  style={getNavStyle("/UserMyCases")}
                >
                  <i data-feather="airplay" style={{ color: "#FFF" }}></i>
                  <span className="title" style={{ color: "#FFF" }}>
                    My Cases
                  </span>
                </Link>
              </li>

              <li className="nav-item start">
                <Link
                  to="/UserUsageGraph"
                  className="nav-link nav-toggle"
                  style={getNavStyle("/UserUsageGraph")}
                >
                  <i
                    className="fa-solid fa-chart-area"
                    style={{ color: "#FFF" }}
                  ></i>
                  <span className="title" style={{ color: "#FFF" }}>
                    Usage
                  </span>
                </Link>
              </li>

              <li className="nav-item start">
                <Link
                  to="/UserChatHistory"
                  className="nav-link nav-toggle"
                  style={getNavStyle("/UserChatHistory")}
                >
                  <i
                    data-feather="message-square"
                    style={{ color: "#FFF" }}
                  ></i>
                  <span className="title" style={{ color: "#FFF" }}>
                    Chat History
                  </span>
                </Link>
              </li>

              <li className="nav-item start">
                <Link
                  to="/UserChangePassword"
                  className="nav-link nav-toggle"
                  style={getNavStyle("/UserChangePassword")}
                >
                  <i
                    data-feather="lock"
                    style={{ color: "#FFF" }}
                  ></i>
                  <span className="title" style={{ color: "#FFF" }}>
                    Change Password
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSidebarContainer;